


















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import ImageLayout from '@/components/ImageLayout.vue';

@Component({
  components: {ImageLayout},
})
export default class Leads extends Vue {
}
